<template>
  <div>
    <button
        data-toggle="collapse"
        :href="`#${id}`"
        role="button"
        :aria-expanded="isOpen.toString()"
        :aria-controls="controlName"
        :disabled="disabled"
        @click.once="openOnce"
        :class="{collapsed: !isOpen, disabled: disabled}">
      <slot name="section-header"></slot>
    </button>
    <div class="collapse" :class="{show: isOpen}" :id="id">
      <slot name="section-contents" v-if="open"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import disabledMixin from '~/mixins/disabledMixin'

export default Vue.extend({
  mixins: [disabledMixin],
  data(){
    return {
      open: this.isOpen
    }
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    controlName: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    openOnce(): void {
      // triggers the contents of the collapsed section to render
      if (!this.open) this.open = !this.open
    }
  }
});
</script>